import { Directive } from '@angular/core';

/**
 * Marker directive used to detect projected custom modal footer content.
 *
 * Usage by consumers:
 *   <ng-container modal-footer>...</ng-container>
 */
@Directive({
    selector: '[modal-footer]',
})
export class ModalFooterDirective {}
